import { Lock } from 'lucide-react';
import { useConfig } from '@/api/config';
import ComingSoon from './ComingSoon';

export default function LicensesPage() {
  const { data: config, isLoading } = useConfig();

  // While config is in flight, show the existing ComingSoon — fewer
  // visual surprises than a brief disabled flash if the flag is true.
  if (isLoading || config?.licenseManagerEnabled !== false) {
    return (
      <ComingSoon
        title="Licenses"
        fallbackHref="/licenses"
        description="The redesigned Licenses page (card grid, expiration badges) is scheduled for v2.1."
      />
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="rounded-full bg-muted p-3 mb-4">
        <Lock className="h-6 w-6 text-muted-foreground" aria-hidden />
      </div>
      <h1 className="text-xl font-semibold">Licenses are disabled</h1>
      <p className="mt-2 text-sm text-muted-foreground max-w-md">
        The License Manager is turned off on this server. Set the{' '}
        <code className="px-1 py-0.5 rounded bg-muted font-mono text-xs">
          RM_LICENSE_MANAGER_ENABLED=true
        </code>{' '}
        environment variable and restart Resource Manager to enable the
        Licenses page.
      </p>
    </div>
  );
}
